export default __webpack_public_path__ + "static/media/avi.9abcff08.svg";